import { z } from "zod";

import { OfferDtoSchema } from "./offers";
import { OnsiteEditDtoSchema } from "./onsite-edits";
import { OnsiteInjectionDtoSchema } from "./onsite-injections";
import {
  CreateShippingRateGroupDtoSchema,
  ShippingRateGroupDtoSchema,
} from "./shipping-rate-groups";

export const PriceChangeUnitList = ["percent", "dollar"] as const;
export type PriceChangeUnit = (typeof PriceChangeUnitList)[number];
export const PriceChanceRoundingList = [
  "none",
  "custom",
  "up",
  "down",
] as const;
export type PriceChangeRounding = (typeof PriceChanceRoundingList)[number];
export const PriceDirectionList = ["increase", "decrease"] as const;
export type PriceDirection = (typeof PriceDirectionList)[number];

export const GroupStateRoundedSidesList = [
  "both",
  "left",
  "right",
  "",
] as const;
export type GroupStateRoundedSides =
  (typeof GroupStateRoundedSidesList)[number];

export const VariationDtoSchema = z.object({
  id: z.string().uuid(),
  experienceId: z.string().uuid(),
  name: z.string(),
  percentage: z.number(),
  isControl: z.boolean().default(false),
  order: z.number().int(),
  priceChangeUnit: z.enum(PriceChangeUnitList).nullish(),
  priceChange: z.string().nullish(),
  onsiteEdits: OnsiteEditDtoSchema.array().optional().default([]),
  onsiteInjections: OnsiteInjectionDtoSchema.nullish(),
  offer: OfferDtoSchema.nullish(),
  shippingRateGroups: z.optional(
    ShippingRateGroupDtoSchema.array().default([])
  ),
  excludeProducts: z.boolean().default(false).optional(),
  includeProducts: z.boolean().default(false).optional(),
  testExperienceId: z.string().nullish(),
  functionSyncError: z.boolean().default(false),
});

export type VariationDto = z.infer<typeof VariationDtoSchema>;

export const PatchVariationDtoSchema = z
  .object({
    experienceId: z.string().uuid(),
    name: z.string(),
    percentage: z.number(),
    isControl: z.boolean().default(false),
    order: z.number().int(),
    priceChangeUnit: z.enum(PriceChangeUnitList).nullish(),
    priceChange: z.string().nullish(),
    excludeProducts: z.boolean().optional().default(false),
    includeProducts: z.boolean().optional().default(false),
    functionSyncError: z.boolean().default(false),
  })
  .partial()
  .extend({
    id: z.string().uuid(),
  });

export type PatchVariationDto = z.infer<typeof PatchVariationDtoSchema>;

export const CreateVariationDtoSchema = VariationDtoSchema.omit({
  onsiteEdits: true,
  onsiteInjections: true,
  functionSyncError: true,
}).extend({
  experienceId: z.string().uuid().optional(),
  shippingRateGroups: z.optional(
    CreateShippingRateGroupDtoSchema.array().default([])
  ),
});

export type CreateVariationDto = z.infer<typeof CreateVariationDtoSchema>;
